import * as Designs from '@pkg/entities/designs';
import { Action } from '@/lib/enums';

/**
 * Provides publishing actions for scenarios.
 */
const usePublishScenario = ({ access, design, scenario }) => {
  const publishRole = Designs.mutations.usePublishRole();
  const mutations = Designs.useStore((state) => state.mutations);

  const canPublish = Boolean(
    scenario?.entity?.uuid &&
    access?.isReady &&
    access.can(
      { uuid: scenario.entity.uuid, __type: scenario.entity.__type },
      null,
      Action.PUBLISH
    )
  );

  /**
   * Publishes a role from one design (scenario) over a role with the same
   * uuid on the main design.
   *
   * @param {Object} input
   * @param {String} input.title
   * @param {String} input.uuid
   * @param {String} input.message
   *
   * @return {Object}
   */
  const publish = async ({ title, uuid, message }) => {
    if (!canPublish) {
      return;
    }

    const published = await publishRole(design.uuid, {
      sourceId: uuid,
      targetId: uuid,
      title,
    });
    await mutations.archiveScenario(design.uuid, message);

    return published;
  };

  return {
    canPublish,
    publish,
  };
};

export default usePublishScenario;
